import { useSearchParams } from "react-router-dom";
import { DEFAULT_TAB, TAB_PARAM_MAP } from "../constants";
import type { TabValue } from "../types";

interface UseReflectionTabReturn {
	activeTab: TabValue;
}

export function useReflectionTab(): UseReflectionTabReturn {
	const [searchParams] = useSearchParams();

	const getActiveTab = (): TabValue => {
		const tabParam = searchParams.get("tab");
		if (tabParam && TAB_PARAM_MAP[tabParam]) {
			return TAB_PARAM_MAP[tabParam] as TabValue;
		}
		return DEFAULT_TAB as TabValue;
	};

	return {
		activeTab: getActiveTab(),
	};
}
